import { colors, fontSize, size } from '@styles/theme'
import styled from '@emotion/styled/macro'
import useDialog from '@hooks/useDialog'

import { Button, ButtonBase, Dialog, IconButton } from '@mui/material'
import { PiArrowCounterClockwise, PiBackspace, PiBackspaceBold, PiCaretDownBold, PiClockCounterClockwise, PiClockCounterClockwiseBold, PiXBold } from 'react-icons/pi'
import BackTopbar from '@elements/BackTopbar'

const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`

const InputContainer = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
  padding: ${size(2.5)} 0;
  border-bottom: 0.5px solid rgba(255,255,255, 0.25);
  min-height: ${size(8)};
`

const InputLabel = styled.span`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  font-weight: bold;
  font-size: ${fontSize('sm')};
  padding-left: ${size(1)};
`

const InputDisplay = styled(ButtonBase)`
  display: flex;
  align-items: center;
  margin-left: auto;
  justify-content: flex-end;
  flex-wrap: wrap;
  flex-shrink: 1;
  gap: ${size(0.5)};

  & .stat-tag {
    background-color: ${colors.statusColors['right_now']('primary')};
    font-size: ${fontSize('xs')};
    font-weight: 500;
  }
`

const Contents = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: scroll;
  padding: ${size(1)} 0;
`

const BottomActions = styled.div`
  display: flex;
  flex-shrink: 0;
  height: ${size(7)};
  width: 100%;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid rgba(255,255,255,0.1);
`

const NoticeText = styled.span`
  display: flex;
  align-items: center;
  margin-left: ${size(1.5)};

  font-size: ${fontSize('sm')};
  font-weight: bold;
  text-decoration: underline;
  color: grey;
`

const SaveButton = styled(Button)`
  margin: 0;
  border-radius: 100px;
  color: white;
  background-color: ${colors.statusColors.right_now('primary')};
  flex-grow: 0;
  margin-right: ${size(1)};
  padding-left: ${size(3)};
  padding-right: ${size(3)};
`

const ClearButton = styled(IconButton)`
  display: flex;
  align-items: center;
  margin-right: ${size(1)};
  padding: ${size(0.75)};
  border-radius: 100px;
  border: 1px solid grey;
  color: grey;
`

const paperStyles = {
  width: '75vw',
  maxHeight: '60vh',
  position: 'relative',
  backgroundColor: '#333333',
  borderRadius: '12px',
  display: 'flex',
  flexDirection: 'column',
  border: '0.5px solid rgba(255,255,255, 0.25)',
  overflowY: 'hidden',
}

const paperSlotProps = {
  paper: {
    style: paperStyles
  }
}

const DialogInput = ({ displayValue, label, onClear, children, notice, slotProps={ inputContainer: {} } }) => {
  const snakeCaseLabel = label.replace(' ', '_')
  const [isOpen, setOpen, setClosed] = useDialog(`nearby_profile_form_${snakeCaseLabel}`, 'open')

  const renderDisplayValue = () => {
    if (!displayValue || (Array.isArray(displayValue) && displayValue.length === 0)) {
      return 'Select'
    } else {
      return displayValue
    }
  }

  const handleClear = () => {
    if (typeof onClear !== 'function') return;
    onClear()
    setClosed()
  }

  return (
    <Container>
      <Dialog
        slotProps={paperSlotProps}
        open={isOpen}
        onClose={setClosed}>
        <BackTopbar
          title={label}
          containerProps={{ style: { backgroundColor: 'transparent', position: 'relative', flexShrink: 0, height: size(7) } }}
          titleProps={{ style: { fontSize: fontSize('md'), marginLeft: size(1) } }}>
          <ClearButton onClick={handleClear}>
            <PiClockCounterClockwise alt='clear value' size={size(2.5)} />
          </ClearButton>
        </BackTopbar>
        <Contents>
          {children}
        </Contents>
        <BottomActions>
          <NoticeText>{notice}</NoticeText>
          <SaveButton onClick={setClosed}>Done</SaveButton>
        </BottomActions>
      </Dialog>
      <InputContainer {...slotProps?.inputContainer || {}}>
        <InputLabel>
          {label}
        </InputLabel>
        <InputDisplay onClick={setOpen}>
          {renderDisplayValue()}
        </InputDisplay>
        <PiCaretDownBold
          size={size(2)}
          style={{
            strokeWidth: size(2),
            margin: `0 ${size(1.5)}`,
            flexShrink: 0,
          }}
        />
      </InputContainer>
    </Container>
  )
}

export { DialogInput }
